import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container } from '@/components/container';
import {
  Toolbar,
  ToolbarDescription,
  ToolbarHeading,
  ToolbarPageTitle,
} from '@/partials/toolbar';
import { PageNavbar } from '@/pages/account';
import { useLayout } from '@/providers';
import { HarborListings } from './HarborListings';
import { KeenIcon } from '@/components';
import { usePermissions } from '@/hooks/usePermissions';
import { useCurrentUserRoles } from '@/utils/userRole';
import { UserRoles } from '@/constant';

const HarborManagement = () => {
  const { currentLayout } = useLayout();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const roles = useCurrentUserRoles();
  const isPlatformAdmin = roles.includes(UserRoles.ADMIN);

  const handleCreateHarbor = () => {
    navigate('/harbors/create');
  };

  return (
    <Fragment>
      <PageNavbar />
      {currentLayout?.name === 'demo1-layout' && (
        <Container>
          <Toolbar>
            <ToolbarHeading>
              <ToolbarPageTitle id="harbor-management-heading" />
              <ToolbarDescription>
                You can manage your harbor management here.
              </ToolbarDescription>
            </ToolbarHeading>
            {hasPermission('harbor_management_read') && (
              <div className="flex w-full flex-wrap items-center gap-2.5 sm:w-auto sm:justify-end">
                {hasPermission('read_harbor_approval_requests') && (
                  <button
                    type="button"
                    className="btn btn-sm btn-light flex min-w-0 items-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-auto"
                    onClick={() => navigate('/harbors/requests')}
                    aria-label="View harbor requests"
                  >
                    <KeenIcon
                      type="filled"
                      icon="notepad"
                      className="text-gray-500"
                    />
                    Harbor Requests
                  </button>
                )}
                {hasPermission('harbor_deletion_requests_read') && (
                  <button
                    type="button"
                    className="btn btn-sm btn-light flex min-w-0 items-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-auto"
                    onClick={() => navigate('/harbors/deletion-requests')}
                    aria-label="View harbor deletion requests"
                  >
                    <KeenIcon
                      type="filled"
                      icon="trash"
                      className="text-orange-500"
                    />
                    Deletion Requests
                  </button>
                )}
                {isPlatformAdmin &&
                  hasPermission('harbor_management_create') && (
                    <button
                      type="button"
                      className="btn btn-sm btn-light flex min-w-0 items-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-auto"
                      onClick={() => navigate('/harbors/bulk-import')}
                      aria-label="Bulk import harbors"
                    >
                      <KeenIcon
                        type="filled"
                        icon="file-up"
                        className="text-gray-500"
                      />
                      Bulk Import
                    </button>
                  )}
                {isPlatformAdmin &&
                  hasPermission('harbor_management_bulk_update') && (
                    <button
                      type="button"
                      className="btn btn-sm btn-light flex min-w-0 items-center gap-2 focus:outline-none focus:ring-2 focus:ring-blue-500 w-full sm:w-auto"
                      onClick={() => navigate('/harbors/bulk-update')}
                      aria-label="Bulk update harbors"
                    >
                      <KeenIcon
                        type="filled"
                        icon="pencil"
                        className="text-gray-500"
                      />
                      Bulk Update
                    </button>
                  )}
                {hasPermission('harbor_management_create') && (
                  <button
                    type="button"
                    className="btn btn-sm btn-light w-full sm:w-auto"
                    onClick={handleCreateHarbor}
                    aria-label="Add new harbor"
                  >
                    Add New Harbor
                  </button>
                )}
              </div>
            )}
          </Toolbar>
        </Container>
      )}
      <Container>
        <HarborListings />
      </Container>
    </Fragment>
  );
};

export { HarborManagement };
